import React, {useState} from 'react'
import ContactForm from '../Components/ContactForm'
import Confirmation from '../Components/Confirmation'

function Contact() {
  
  const [isSubmitted, setIsSubmitted] = useState(false);

  const handleFormSubmit = (formData) => {
    // Here you can handle form submission, e.g., send it to an API
    console.log('Form submitted:', formData);
    // After handling submission, update the state to show confirmation
    setIsSubmitted(true);
  };
  
  return (
    <div className='bg-gradient-to-b from-slate-50 to-white min-h-screen'>
      {/* Hero Section */}
      <div className='py-16 lg:py-24 bg-gradient-to-br from-slate-900 via-slate-800 to-slate-900'>
        <div className='max-w-4xl mx-auto px-6 lg:px-8 text-center'>
          <h1 className='hero-title mb-6'>Contact Us</h1>
          <p className='text-lg md:text-xl text-slate-300 leading-relaxed max-w-3xl mx-auto'>
            Ready to bring your digital vision to life? We'd love to hear about your project 
            and discuss how we can help your business thrive in the digital world.
          </p>
        </div>
      </div>

      {/* Contact Content */}
      <div className='max-w-4xl mx-auto px-6 lg:px-8 py-16'>
        {isSubmitted ? (
          <Confirmation onReset={() => setIsSubmitted(false)} />
        ) : (
          <>
            {/* Contact Information Cards */}
            <div className='grid md:grid-cols-2 gap-8 mb-12'>
              {/* Get in Touch */}
              <div className='card p-6'>
                <div className='flex items-center gap-3 mb-4'>
                  <div className='w-10 h-10 bg-gradient-to-r from-blue-500 to-cyan-500 rounded-lg flex items-center justify-center'>
                    <svg className='w-5 h-5 text-white' fill='currentColor' viewBox='0 0 24 24'>
                      <path d='M12 12.713l-11.985-9.713h23.97l-11.985 9.713zm0 2.574l-12-9.725v15.438h24v-15.438l-12 9.725z'/>
                    </svg>
                  </div>
                  <h3 className='text-xl font-semibold text-slate-800'>Get in Touch</h3>
                </div>
                <p className='text-slate-600 mb-4 leading-relaxed'>
                  Whether you have a specific project in mind or just want to explore possibilities, 
                  we're here to help turn your ideas into reality.
                </p>
                <div className='space-y-2'>
                  <a href='mailto:james@wallacesoftware.io' className='flex items-center gap-2 text-blue-600 hover:text-blue-700 transition-colors duration-200'>
                    <svg className='w-4 h-4' fill='currentColor' viewBox='0 0 24 24'>
                      <path d='M12 12.713l-11.985-9.713h23.97l-11.985 9.713zm0 2.574l-12-9.725v15.438h24v-15.438l-12 9.725z'/>
                    </svg>
                    james@wallacesoftware.io
                  </a>
                </div>
              </div>

              {/* Response Time */}
              <div className='card p-6'>
                <div className='flex items-center gap-3 mb-4'>
                  <div className='w-10 h-10 bg-gradient-to-r from-green-500 to-emerald-500 rounded-lg flex items-center justify-center'>
                    <svg className='w-5 h-5 text-white' fill='currentColor' viewBox='0 0 24 24'>
                      <path d='M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z'/><path d='M12.5 7H11v6l5.25 3.15.75-1.23-4.5-2.67z'/>
                    </svg>
                  </div>
                  <h3 className='text-xl font-semibold text-slate-800'>Quick Response</h3>
                </div>
                <p className='text-slate-600 leading-relaxed'>
                  We typically respond to all inquiries within 24 hours. For urgent projects, 
                  don't hesitate to mention it in your message.
                </p>
              </div>
            </div>

            {/* Contact Form */}
            <div className='card p-8'>
              <div className='text-center mb-8'>
                <h2 className='text-2xl font-semibold text-slate-800 mb-2'>Start Your Project</h2>
                <p className='text-slate-600'>Tell us about your project and we'll get back to you soon.</p>
              </div>
              <ContactForm onSubmit={handleFormSubmit} />
            </div>
          </>
        )}
      </div>
    </div>
  )
}

export default Contact